import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-parking",
  templateUrl: "./med-icon-parking.component.html",
})
export class MedIconParkingComponent extends SvgMixinComponent {}
